import * as types from "../Actions/Types";
import {
    pushpinColumns,
    storeColumns, targetMarketColumns,
    territoryColumns,
} from "../Components/Apps/My Data/Components/MyDataColumns";
import { IMyData, ICloudFolder } from "../Models/Models";
import { message } from "antd";

export const defaultState: IMyData = {
    types: null,

    activeArea: null,
    activeColumns: {
        locations: storeColumns(null),
        territories: territoryColumns,
        pushpins: pushpinColumns,
        targetMarkets: targetMarketColumns,
        other: null,
    },

    typesChanging: false,

    activeType: null,
    activeData: null,
    dataSize: null,
    filters: {
        locations: [],
        territories: [],
        pushpins: [],
        aoiPoints: [],
        aoiShapes: [],
        resultsPoints: [],
        resultsShapes: [],
    },

    tableLoading: false,
    collaborateTerritories: false,
    collaboratePushpins: false,
    currentPage: 1,
    currentPageSize: 25,
    columnToSort: {
        sortColumn: null,
        sortDirection: null,
    },

    cloudFolder: {
        addCloudFolderMessage: "",
        currentCloudFolder: {
            name: "",
            fullPath: "",
            cloudFolders: [],
            cloudFiles: [],
            parent: "",
            id: 0,
            depth: 0,
            isGlobal: false,
            isShapes: false,
            isResults: false,
        },
    },

    cloudFile: {
        updateCloudFileMessage: "",
        updateCloudFileLoading: false,
    },

    selectedKeys: ["10"],

    myDataLoaded: false,

    breadcrumbs: [],
    storeUpdateAuditResult: null,
    badGeocodes: [],
    loadMyDataDataError: null,
    maxFirstLogicRecords: 0,
    maxGoogleRecords: 0,
    useNewGeocodingService: false
};

export const myData = (state = defaultState, action): IMyData => {
    switch (action.type) {
        case types.MY_DATA_LOADED:
            return {
                ...state,
                myDataLoaded: action.data,
            };
        case types.LOAD_MY_DATA_TYPES_SUCCESS:
            return {
                ...state,
                types: {
                    ...state.types,
                    ...action.data,
                },
                myDataLoaded: true,
            };
        case types.LOAD_FROM_SCOUT_MY_DATA_AOI_POINT_TYPES_SUCCESS:
            return {
                ...state,
                types: {
                    ...state.types,
                    aoiPoints: action.data,
                },
            };
        case types.LOAD_FROM_SCOUT_MY_DATA_AOI_SHAPE_TYPES_SUCCESS:
            return {
                ...state,
                types: {
                    ...state.types,
                    aoiShapes: action.data,
                },
            };
        case types.LOAD_FROM_SCOUT_MY_DATA_RESULT_POINT_TYPES_SUCCESS:
            return {
                ...state,
                types: {
                    ...state.types,
                    resultsPoints: action.data,
                },
            };
        case types.LOAD_FROM_SCOUT_MY_DATA_RESULT_SHAPE_TYPES_SUCCESS:
            return {
                ...state,
                types: {
                    ...state.types,
                    resultsShapes: action.data,
                },
            };
        case types.LOAD_MY_DATA_CLOUD_TYPES_SUCCESS:
            return {
                ...state,
                types: {
                    ...state.types,
                    aoiPoints: action.data.aoiPoints,
                    aoiShapes: action.data.aoiShapes,
                    resultsPoints: action.data.resultsPoints,
                    resultsShapes: action.data.resultsShapes,
                },
            };
        case types.MY_DATA_LOAD_RESULTS_POINTS_TYPES_SUCCESS:
            return {
                ...state,
                types: {
                    ...state.types,
                    resultsPoints: action.data,
                    currentCloudTypeDict: createDict(action.data),
                },
            };
        case types.MY_DATA_LOAD_RESULTS_SHAPES_TYPES_SUCCESS:
            return {
                ...state,
                types: {
                    ...state.types,
                    resultsShapes: action.data,
                    currentCloudTypeDict: createDict(action.data),
                },
            };
        case types.MY_DATA_LOAD_AOI_POINTS_TYPES_SUCCESS:
            return {
                ...state,
                types: {
                    ...state.types,
                    aoiPoints: action.data,
                    currentCloudTypeDict: createDict(action.data),
                },
            };
        case types.MY_DATA_LOAD_AOI_SHAPES_TYPES_SUCCESS:
            return {
                ...state,
                types: {
                    ...state.types,
                    aoiShapes: action.data,
                    currentCloudTypeDict: createDict(action.data),
                },
            };
        case types.MY_DATA_BUILD_CURRENT_CLOUD_TYPE_DICT:
            return {
                ...state,
                types: {
                    ...state.types,
                    currentCloudTypeDict: createDict(
                        action.data === "resultsPoint"
                            ? state.types.resultsPoints
                            : action.data === "resultsShape"
                                ? state.types.resultsShapes
                                : action.data === "aoiPoint"
                                    ? state.types.aoiPoints
                                    : action.data === "aoiShape"
                                        ? state.types.aoiShapes
                                        : null
                    ),
                },
            };
        case types.MY_DATA_LOAD_PUSHPIN_TYPES_SUCCESS:
            return {
                ...state,
                types: {
                    ...state.types,
                    pushpins: action.data,
                },
            };
        case types.MY_DATA_LOAD_STORE_TYPES_SUCCESS:
            return {
                ...state,
                types: {
                    ...state.types,
                    locations: action.data,
                },
            };
        case types.MY_DATA_LOAD_TERRITORY_TYPES_SUCCESS:
            return {
                ...state,
                types: {
                    ...state.types,
                    territories: action.data,
                },
            };
        case types.LOAD_MY_DATA_DATA_SUCCESS:
            return {
                ...state,
                dataSize: action.data.dataSize,
                activeArea: action.data.activeArea,
                activeType: action.data.activeType,
                activeData: action.data.activeData,
                tableLoading: false,
                activeColumns: {
                    ...state.activeColumns,
                    locations: action.data.activeColumns,
                    other: null,
                },
                typesChanging: false,
            };
        case types.LOAD_MY_DATA_FAILURE:
            return {
                ...state,
                tableLoading: false,
                loadMyDataDataError: action.data,
            };
        case types.LOAD_MY_DATA_OTHER_SUCCESS:
            return {
                ...state,
                dataSize: action.data.dataSize,
                activeArea: action.data.activeArea,
                activeType: action.data.activeType,
                activeData: action.data.activeData,
                tableLoading: false,
                activeColumns: {
                    ...state.activeColumns,
                    other: action.data.activeColumns,
                },
                typesChanging: false,
            };
        case types.MY_DATA_TYPES_CHANGED:
            return {
                ...state,
                typesChanging: true,
            };
        case types.MY_DATA_REMOVE_ALL_FILTERS:
            if (state.activeArea === "Locations") {
                return {
                    ...state,
                    filters: {
                        ...state.filters,
                        locations: [],
                    },
                };
            } else if (state.activeArea === "Territories") {
                return {
                    ...state,
                    filters: {
                        ...state.filters,
                        territories: [],
                    },
                };
            } else if (state.activeArea === "Pushpins") {
                return {
                    ...state,
                    filters: {
                        ...state.filters,
                        pushpins: [],
                    },
                };
            }
        case types.MY_DATA_REMOVE_FILTER:
            if (state.activeArea === "Locations") {
                return {
                    ...state,
                    filters: {
                        ...state.filters,
                        locations: state.filters.locations.filter(
                            (f) => f.fieldName !== action.data.fieldName
                        ),
                    },
                };
            } else if (state.activeArea === "Territories") {
                return {
                    ...state,
                    filters: {
                        ...state.filters,
                        territories: state.filters.territories.filter(
                            (f) => f.fieldName !== action.data.fieldName
                        ),
                    },
                };
            } else if (state.activeArea === "Pushpins") {
                return {
                    ...state,
                    filters: {
                        ...state.filters,
                        pushpins: state.filters.pushpins.filter(
                            (f) => f.fieldName !== action.data.fieldName
                        ),
                    },
                };
            }
        case types.UPDATE_MY_DATA_FILTERS:
            if (state.activeArea === "Locations") {
                return {
                    ...state,
                    filters: {
                        ...state.filters,
                        locations: [...state.filters.locations, action.data],
                    },
                };
            } else if (state.activeArea === "Territories") {
                return {
                    ...state,
                    filters: {
                        ...state.filters,
                        territories: [...state.filters.territories, action.data],
                    },
                };
            } else if (state.activeArea === "Pushpins") {
                return {
                    ...state,
                    filters: {
                        ...state.filters,
                        pushpins: [...state.filters.pushpins, action.data],
                    },
                };
            }
        case types.UPDATE_MY_DATA_TERRITORY_COLLABORATE:
            return {
                ...state,
                collaborateTerritories: action.data,
            };
        case types.UPDATE_MY_DATA_PUSHPIN_COLLABORATE:
            return {
                ...state,
                collaboratePushpins: action.data,
            };
        case types.GET_USER_PREFERENCES_SUCCESS:
        case types.UPDATE_USER_PREFERENCES_SUCCESS:
            return {
                ...state,
                collaboratePushpins: action.response.data.collaboratePushpins,
                collaborateTerritories: action.response.data.collaborateTerritories,
            };
        case types.SET_MY_DATA_LOADING:
            return {
                ...state,
                tableLoading: action.data,
            };
        case types.UPDATE_MY_DATA_COLUMNS:
            switch (state.activeArea) {
                case "Locations":
                    const activeLocationCols = [...state.activeColumns.locations];

                    if (action.data === "Check All") {
                        for (let i = 0; i < activeLocationCols.length; i++) {
                            activeLocationCols[i].isChecked = true;
                        }
                    } else if (action.data === "Uncheck All") {
                        for (let i = 0; i < activeLocationCols.length; i++) {
                            activeLocationCols[i].isChecked = false;
                        }
                    } else {
                        for (let i = 0; i < activeLocationCols.length; i++) {
                            if (i === action.data) {
                                activeLocationCols[i].isChecked
                  = !activeLocationCols[i].isChecked;
                            }
                        }
                    }

                    return {
                        ...state,
                        activeColumns: {
                            ...state.activeColumns,
                            locations: activeLocationCols,
                        },
                    };
                case "Territories":
                    const activeTerritoryCols = [...state.activeColumns.territories];

                    if (action.data === "Check All") {
                        for (let i = 0; i < activeTerritoryCols.length; i++) {
                            activeTerritoryCols[i].isChecked = true;
                        }
                    } else if (action.data === "Uncheck All") {
                        for (let i = 0; i < activeTerritoryCols.length; i++) {
                            activeTerritoryCols[i].isChecked = false;
                        }
                    } else {
                        for (let i = 0; i < activeTerritoryCols.length; i++) {
                            if (i === action.data) {
                                activeTerritoryCols[i].isChecked
                  = !activeTerritoryCols[i].isChecked;
                            }
                        }
                    }

                    return {
                        ...state,
                        activeColumns: {
                            ...state.activeColumns,
                            territories: activeTerritoryCols,
                        },
                    };
                case "Pushpins":
                    const activePushpinCols = [...state.activeColumns.pushpins];

                    if (action.data === "Check All") {
                        for (let i = 0; i < activePushpinCols.length; i++) {
                            activePushpinCols[i].isChecked = true;
                        }
                    } else if (action.data === "Uncheck All") {
                        for (let i = 0; i < activePushpinCols.length; i++) {
                            activePushpinCols[i].isChecked = false;
                        }
                    } else {
                        for (let i = 0; i < activePushpinCols.length; i++) {
                            if (i === action.data) {
                                activePushpinCols[i].isChecked
                  = !activePushpinCols[i].isChecked;
                            }
                        }
                    }

                    return {
                        ...state,
                        activeColumns: {
                            ...state.activeColumns,
                            pushpins: activePushpinCols,
                        },
                    };
                case "Target Markets":
                    const activeTargetMarketCols = [...state.activeColumns.targetMarkets];

                    if (action.data === "Check All") {
                        for (let i = 0; i < activeTargetMarketCols.length; i++) {
                            activeTargetMarketCols[i].isChecked = true;
                        }
                    } else if (action.data === "Uncheck All") {
                        for (let i = 0; i < activeTargetMarketCols.length; i++) {
                            activeTargetMarketCols[i].isChecked = false;
                        }
                    } else {
                        for (let i = 0; i < activeTargetMarketCols.length; i++) {
                            if (i === action.data) {
                                activeTargetMarketCols[i].isChecked
                                    = !activeTargetMarketCols[i].isChecked;
                            }
                        }
                    }

                    return {
                        ...state,
                        activeColumns: {
                            ...state.activeColumns,
                            targetMarkets: activeTargetMarketCols,
                        },
                    };
                case "Areas of Interest/Points":
                case "Areas of Interest/Geographies":
                case "Results/Points":
                case "Results/Geographies":
                    const activeOtherCols = [...state.activeColumns.other];

                    if (action.data === "Check All") {
                        for (let i = 0; i < activeOtherCols.length; i++) {
                            activeOtherCols[i].isChecked = true;
                        }
                    } else if (action.data === "Uncheck All") {
                        for (let i = 0; i < activeOtherCols.length; i++) {
                            activeOtherCols[i].isChecked = false;
                        }
                    } else {
                        for (let i = 0; i < activeOtherCols.length; i++) {
                            if (i === action.data) {
                                activeOtherCols[i].isChecked = !activeOtherCols[i].isChecked;
                            }
                        }
                    }

                    return {
                        ...state,
                        activeColumns: {
                            ...state.activeColumns,
                            other: activeOtherCols,
                        },
                    };
            }
        case types.MY_DATA_SET_CURRENT_PAGE:
            return {
                ...state,
                currentPage: action.data,
            };
        case types.MY_DATA_SET_PAGE_SIZE:
            return {
                ...state,
                currentPageSize: action.data,
            };
        case types.UPDATE_SORT_DIRECTION:
            return {
                ...state,
                columnToSort: {
                    ...state.columnToSort,
                    sortColumn: action.data.sortColumn,
                    sortDirection: action.data.sortDirection,
                },
            };
        case types.RESET_SORT_DIRECTION:
            return {
                ...state,
                columnToSort: {
                    ...state.columnToSort,
                    sortColumn: null,
                    sortDirection: null,
                },
            };
        case types.MY_DATA_SET_CURRENT_CLOUD_FOLDER:
            return {
                ...state,
                cloudFolder: {
                    ...state.cloudFolder,
                    currentCloudFolder: state.types.currentCloudTypeDict[action.data],
                },
            };
        case types.MY_DATA_ADD_CLOUD_FOLDER_SUCCESS:
            message.destroy();
            message.success("Successfully added", 5);
            return {
                ...state,
                cloudFolder: {
                    ...state.cloudFolder,
                    addCloudFolderMessage: "Successfully added",
                },
            };
        case types.MY_DATA_ADD_CLOUD_FOLDER_FAILURE:
            message.destroy();
            message.error("Failed to add", 5);
            return { ...state };
        case types.MY_DATA_RESET_ADD_CLOUD_FOLDER_MESSAGE:
            return {
                ...state,
                cloudFolder: {
                    ...state.cloudFolder,
                    addCloudFolderMessage: "",
                },
            };
        case types.MY_DATA_DELETE_CLOUD_FOLDER_SUCCESS:
            message.destroy();
            message.success("Successfully deleted", 5);
            return { ...state };
        case types.MY_DATA_DELETE_CLOUD_FOLDER_FAILURE:
            message.destroy();
            message.error("Failed to delete", 5);
            return { ...state };
        case types.MY_DATA_UPDATE_CLOUD_FILE_LOADING:
            return {
                ...state,
                cloudFile: {
                    ...state.cloudFile,
                    updateCloudFileLoading: true,
                },
            };
        case types.MY_DATA_UPDATE_CLOUD_FILE_SUCCESS:
            message.destroy();
            message.success("Successfully updated", 5);
            return {
                ...state,
                cloudFile: {
                    ...state.cloudFile,
                    updateCloudFileLoading: false,
                    updateCloudFileMessage: "Successfully updated",
                },
            };
        case types.MY_DATA_UPDATE_CLOUD_FILE_FAILURE:
            message.destroy();
            message.error("Failed to update", 5);
            return {
                ...state,
                cloudFile: {
                    ...state.cloudFile,
                    updateCloudFileLoading: false,
                },
            };
        case types.MY_DATA_RESET_UPDATE_CLOUD_FILE_MESSAGE:
            return {
                ...state,
                cloudFile: {
                    ...state.cloudFile,
                    updateCloudFileMessage: "",
                },
            };
        case types.MY_DATA_RESULTS_POINTS_DELETE_CLOUD_FILE_SUCCESS:
            message.destroy();
            message.success("Successfully deleted", 5);
            return {
                ...state,
                types: {
                    ...state.types,
                    resultsPoints: action.data,
                },
            };
        case types.MY_DATA_RESULTS_SHAPES_DELETE_CLOUD_FILE_SUCCESS:
            message.destroy();
            message.success("Successfully deleted", 5);
            return {
                ...state,
                types: {
                    ...state.types,
                    resultsShapes: action.data,
                },
            };
        case types.MY_DATA_AOI_POINTS_DELETE_CLOUD_FILE_SUCCESS:
            message.destroy();
            message.success("Successfully deleted", 5);
            return {
                ...state,
                types: {
                    ...state.types,
                    aoiPoints: action.data,
                },
            };
        case types.MY_DATA_AOI_SHAPES_DELETE_CLOUD_FILE_SUCCESS:
            message.destroy();
            message.success("Successfully deleted", 5);
            return {
                ...state,
                types: {
                    ...state.types,
                    aoiShapes: action.data,
                },
            };
        case types.MY_DATA_DELETE_CLOUD_FILE_FAILURE:
            message.destroy();
            message.error("Failed to delete", 5);
            return { ...state };
        case types.MY_DATA_SET_ACTIVE_TYPE:
            return {
                ...state,
                selectedKeys: [action.data],
            };
        case types.MY_DATA_SET_BREADCRUMBS:
            return {
                ...state,
                breadcrumbs: action.data,
            };

        case types.MY_DATA_LOAD_STORE_FILE_AUDIT_SUCCESS:
            return {
                ...state,
            };
        case types.MY_DATA_LOAD_STORE_FILE_AUDIT_SUCCESS:
            return {
                ...state,
            };
        case types.MY_DATA_LOAD_STORE_SET_BAD_GEOCODES:
            return {
                ...state,
                badGeocodes: action.data,
            };
        case types.MY_DATA_SET_MAX_FIRSTLOGIC_RECORDS:
            return {
                ...state,
                maxFirstLogicRecords: action.data,
            };
        case types.MY_DATA_SET_MAX_GOOGLE_RECORDS:
            return {
                ...state,
                maxGoogleRecords: action.data,
            };
        case types.MY_DATA_SET_USE_NEW_GEOCODING_SERVICE:
            return {
                ...state,
                useNewGeocodingService: action.data,
            };
        default:
            return state;
    }
};

const createDict = (data: ICloudFolder) => {
    const dict = {};
    const recurseYou = (parentFolder: ICloudFolder) => {
        dict[parentFolder.fullPath] = parentFolder;
        for (let i = 0; i < parentFolder.cloudFolders.length; i++) {
            recurseYou(parentFolder.cloudFolders[i]);
        }
    };

    recurseYou(data);

    return dict;
};
